import { render } from "./Bannercomponent.vue?vue&type=template&id=c623c360&lang=true"
import script from "./Bannercomponent.vue?vue&type=script&lang=js"
export * from "./Bannercomponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__